module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gitfAlertView"
    }
  }, [_c('div', {
    staticClass: "gitbottomView"
  }, [_c('van-row', _vm._l((_vm.giftList), function(item, index) {
    return _c('van-col', {
      key: index,
      attrs: {
        "span": "6"
      }
    }, [_c('div', {
      staticClass: "list",
      class: index == _vm.selected ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.selectGiftAction(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "money"
    }, [_vm._v(_vm._s(item.price / 100)), _c('span', [_vm._v("元")])])])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "paybar"
  }, [_c('div', {
    staticClass: "paynumber"
  }, [_c('span', [_vm._v("数量")]), _vm._v(" "), _c('van-stepper', {
    attrs: {
      "min": 1,
      "max": 10000,
      "step": 1
    },
    on: {
      "change": _vm.changeOnClick
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "paybutton"
  }, [_c('span', {
    staticClass: "cost"
  }, [_vm._v("合计: " + _vm._s(_vm.sumMoney) + "元")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.bugGifAction()
      }
    }
  }, [_vm._v("支付")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-920fc988"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/giftAlertView.vue
// module id = 306
// module chunks = 0